module.exports = __webpack_public_path__ + "static/img/logo.e264b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 588
// module chunks = 1